<template>
  <div id="container" class="library_st main_introduce">
    <!-- Main Visible -->
    <div class="section main_viswrap">
      <div class="inner main_vis">
        <div class="m_vis_top an_a ease">
          <span class="an_t heroName">{{
            $t('views.intro.libraryintro.ealice3')
          }}</span>
          <h1 class="heroTitleAlt">
            {{ $t('views.intro.libraryintro.9322') }}
          </h1>
        </div>
        <div class="btn_wrap">
          <div class="bdsi_f1">
            <router-link :to="{ name: 'library' }" class="box_btn"
              ><span class="an_t">{{
                $t('views.intro.libraryintro.4830')
              }}</span></router-link
            >
          </div>
        </div>
      </div>
    </div>

    <div class="section fill pb pt introduce_img">
      <div class="inner">
        <div class="txt">
          <div class="self icon"></div>
          <h2>
            {{ $t('views.intro.libraryintro.213') }}<br /><em>{{
              $t('views.intro.libraryintro.5476')
            }}</em>
          </h2>
          <p>
            {{ $t('views.intro.libraryintro.3093') }}
          </p>
        </div>
        <div class="img">
          <!-- <img src="@/assets/images/svg/library_intro.svg" alt="" /> -->
        </div>
      </div>
    </div>

    <!-- 인기 셀프북 -->
    <!--
    <div class="section full introduce_list pb">
      <div class="inner">
        <div class="tit_wrap">
          <div class="best icon"></div>
          <div class="tit_txt">
            <p class="blind">{{ $t('views.intro.libraryintro.ealice2') }}</p>
          </div>
        </div>

        <div class="eplist item_columns_4">
          <div class="swipe_wrap">
            <div class="swipe_area">
              <div class="swipe_content">
                <ul class="item_list">
                  <li>
                    <div class="cover_wrap">
                      <div class="dim"></div>
                      <router-link :to="{ name: 'store' }" class="thum_wrap">
                        class="thum_wrap" >
                        <img
                          src="@/assets/images/cover/temp_book_cover1.jpg"
                          alt="정치학의 이해 제 2판"
                        />
                        <span class="iconbox"
                          ><span class="meta_editer note active"
                            ><span class="an_t">노트</span></span
                          ></span
                        >
                      </router-link>
                    </div>
                    <div class="info_wrap">
                      <h3 class="meta_title">{{ $t('views.intro.libraryintro.6985') }}</h3>
                    </div>
                  </li>
                  <li>
                    <div class="cover_wrap">
                      <div class="dim"></div>
                      <router-link :to="{ name: 'store' }" class="thum_wrap">
                        <img
                          src="@/assets/images/cover/temp_book_cover2.jpg"
                          alt="정치학의 이해 제 2판"
                        />
                        <span class="iconbox"
                          ><span class="meta_editer note active"
                            ><span class="an_t">노트</span></span
                          ></span
                        >
                      </router-link>
                    </div>
                    <div class="info_wrap">
                      <h3 class="meta_title">{{ $t('views.intro.libraryintro.214') }}</h3>
                    </div>
                  </li>
                  <li>
                    <div class="cover_wrap">
                      <div class="dim"></div>
                      <router-link :to="{ name: 'store' }" class="thum_wrap">
                        <img
                          src="@/assets/images/cover/temp_book_cover3.jpg"
                          alt="얼식중 중 유해오염물질 위해평가 실무 표분 매뉴"
                        />
                        <span class="iconbox"
                          ><span class="meta_editer note"
                            ><span class="an_t">노트</span></span
                          ></span
                        >
                      </router-link>
                    </div>
                    <div class="info_wrap">
                      <span class="meta_title"
                        >{{ $t('views.intro.libraryintro.3573') }}</span
                      >
                    </div>
                  </li>
                  <li>
                    <div class="cover_wrap">
                      <router-link :to="{ name: 'store' }" class="thum_wrap">
                        <img
                          src="@/assets/images/cover/temp_book_cover4.jpg"
                          alt="현대 심리치료와 상담이론, 마음의 치와아 상담으로 가는 길"
                        />
                        <span class="iconbox"
                          ><span class="meta_editer note"
                            ><span class="an_t">노트</span></span
                          ></span
                        >
                      </router-link>
                    </div>
                    <div class="info_wrap">
                      <h3 class="meta_title">{{ $t('views.intro.libraryintro.1934') }}</h3>
                    </div>
                  </li>
                  <li>
                    <div class="cover_wrap">
                      <router-link :to="{ name: 'store' }" class="thum_wrap">
                        <img
                          src="@/assets/images/cover/temp_book_cover5.jpg"
                          alt="현대 심리치료와 상담이론, 마음의 치와아 상담으로 가는 길"
                        />
                        <span class="iconbox"
                          ><span class="meta_editer note"
                            ><span class="an_t">노트</span></span
                          ></span
                        >
                      </router-link>
                    </div>
                    <div class="info_wrap">
                      <span class="meta_title"
                        >{{ $t('views.intro.libraryintro.7891') }}</span
                      >
                    </div>
                  </li>
                  <li>
                    <div class="cover_wrap">
                      <router-link :to="{ name: 'store' }" class="thum_wrap">
                        class="thum_wrap" >
                        <img
                          src="@/assets/images/cover/temp_book_cover6.jpg"
                          alt="현대 물리학"
                        />
                        <span class="iconbox"
                          ><span class="meta_editer note active"
                            ><span class="an_t">노트</span></span
                          ></span
                        >
                      </router-link>
                    </div>
                    <div class="info_wrap">
                      <span class="meta_title">{{ $t('views.intro.libraryintro.6469') }}</span>
                    </div>
                  </li>
                  <li>
                    <div class="cover_wrap">
                      <router-link :to="{ name: 'store' }" class="thum_wrap">
                        class="thum_wrap" >
                        <img
                          src="@/assets/images/cover/temp_book_cover7.jpg"
                          alt="현대 물리학"
                        />
                        <span class="iconbox"
                          ><span class="meta_editer note active"
                            ><span class="an_t">노트</span></span
                          ></span
                        >
                      </router-link>
                    </div>
                    <div class="info_wrap">
                      <h3 class="meta_title">{{ $t('views.intro.libraryintro.5947') }}</h3>
                    </div>
                  </li>
                  <li>
                    <div class="cover_wrap">
                      <div class="dim"></div>
                      <router-link :to="{ name: 'store' }" class="thum_wrap">
                        <img
                          src="@/assets/images/cover/temp_book_cover8.jpg"
                          alt="이론과 연습 - 일반위상수학 개정판"
                        />
                        <span class="iconbox"
                          ><span class="meta_editer note active"
                            ><span class="an_t">노트</span></span
                          ></span
                        >
                      </router-link>
                    </div>
                    <div class="info_wrap">
                      <h3 class="meta_title">{{ $t('views.intro.libraryintro.2412') }}</h3>
                    </div>
                  </li>
                  <li>
                    <div class="cover_wrap">
                      <div class="dim"></div>
                      <router-link :to="{ name: 'store' }" class="thum_wrap">
                        class="thum_wrap" >
                        <img
                          src="@/assets/images/cover/temp_book_cover9.jpg"
                          alt="이론과 연습 - 일반위상수학 개정판"
                        />
                        <span class="iconbox"
                          ><span class="meta_editer note active"
                            ><span class="an_t">노트</span></span
                          ></span
                        >
                      </router-link>
                    </div>
                    <div class="info_wrap">
                      <span class="meta_title"
                        >{{ $t('views.intro.libraryintro.4153') }}</span
                      >
                    </div>
                  </li>
                  <li>
                    <div class="cover_wrap">
                      <div class="dim"></div>
                      <router-link :to="{ name: 'store' }" class="thum_wrap">
                        class="thum_wrap" >
                        <img
                          src="@/assets/images/cover/temp_book_cover10.jpg"
                          alt="이론과 연습 - 일반위상수학 개정판"
                        />
                        <span class="iconbox"
                          ><span class="meta_editer note active"
                            ><span class="an_t">노트</span></span
                          ></span
                        >
                      </router-link>
                    </div>
                    <div class="info_wrap">
                      <h3 class="meta_title">{{ $t('views.intro.libraryintro.7189') }}</h3>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="swipe_nav">
              <button type="button" class="svg_swipe_prew">
                <span class="blind">이전</span>
              </button>
              <button type="button" class="svg_swipe_next">
                <span class="blind">{{ $t('common.ui.next') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    -->

    <!-- SelfBook - banner
		<div class="section fill banner_n1">
			<div class="inner">
				<div class="banner_wrap">
					<p>
						<span class="img_banner"></span>
						<span class="blind">{{ $t('views.intro.libraryintro.3806') }}</span>
					</p>
				</div>
			</div>
		</div>
		 -->

    <!-- SelfBook - banner -->
    <!--<div class="section fill selfbook_banner_n2">
			<div class="inner">
				<div class="banner_wrap">
					<p>
						<span class="img_banner"></span>
						<span class="blind">{{ $t('views.intro.libraryintro.8993') }}</span>
					</p>
					<p>{{ $t('views.intro.libraryintro.8393') }}<br/>{{ $t('views.intro.libraryintro.2534') }}<br/>{{ $t('views.intro.libraryintro.pod') }}</p>
					<div class="btn_wrap">
						<a href="../셀프북이용안내페이지연결확인중.html" class="box_btn"><span class="an_t">{{ $t('views.intro.libraryintro.5083') }}</span></a>
					</div>
				</div>
			</div>
		</div>-->
    <HelpDesk />
  </div>
</template>

<script>
import HelpDesk from '@/components/common/HelpDesk.vue'

export default {
  name: 'LibraryIntro',
  components: { HelpDesk }
}
</script>

<style lang="scss" scoped></style>
